import React from "react";
import { useNavigate } from "react-router-dom";

export default function SignInButton() {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate("/SignIn")}
      className="btn rounded-3 fw-bold px-3 py-2 signin-btn"
    >
      Sign In
    </button>
  );
}
